export const ROUTE_NAMES = {
  AUTH_LAYOUT: 'AuthLayout',
  BASE_LAYOUT: 'BaseLayout',
  BASE_LAYOUT_TAB: 'BaseLayoutTab',
  SETTINGS_LAYOUT: 'SettingsLayout',
  SETTINGS_APPEARANCE: 'SettingsAppearance',
  SETTINGS_ACCOUNT: 'SettingsAccount',
  SETTINGS_SIGNATURE: 'SettingsSignature',
  SETTINGS_SIGNATURE_EDIT: 'SettingsSignatureEdit',
  SETTINGS_GENERAL: 'SettingsGeneral',
  SETTINGS_SECURITY: 'SettingsSecurity',
  SETTINGS_CONTACTS: 'SettingsContacts',
  SETTINGS_AUTOREPLY: 'SettingsAutoreply',
  SETTINGS_UPGRADE: 'SettingsUpgrade',
  SECURITY_2FA: 'Settings2FA',
  SECURITY_APPLICATION_PASSWORDS: 'SettingsApplicationPasswords',
  SECURITY_ACCOUNT_PASSWORD: 'SettingsAccountPassword',
  SECURITY_EXTERNAL_CONTENT: 'SettingsExternalContent',
  CONTACTS_ADDRESSBOOKS: 'ContactsAdressbooks',
  CONTACTS_CONTACTS: 'ContactsContacts',
  CONTACTS_GROUPS: 'ContactsGroups',
  SECURITY_EVENTS: 'SettingsEvents',
  SETTINGS_FOLDERS: 'SettingsFolders',
  SETTINGS_FILTERS: 'SettingsFilters',
  SETTINGS_MCP_SERVER: 'SettingsMcpServer',

  AUTH_LOGIN_USER_SELECT: 'AuthLoginUserSelect',
  AUTH_LOGIN_PASSWORD: 'AuthLoginPassword',
  AUTH_2FA: 'Auth2FA',
  AUTH_TOTP: 'AuthTotp',
  AUTH_WEBAUTHN: 'AuthWebauthn',
  AUTH_FORCE_PASSWORD_CHANGE: 'AuthForcePasswordChange',

  MAILBOX: 'Mailbox',
  MAILBOX_THREAD: 'MailboxThread',
  MAILBOX_THREAD_TAB: 'MailboxThreadTab',
  MAILBOX_SEARCH: 'MailboxSearch',
  MAILBOX_SEARCH_THREAD: 'MailboxSearchThread',
  MAILBOX_SOURCE: 'MailboxSource',
  MAILBOX_PRINT: 'MailboxPrint',
  MAILBOX_THREAD_PRINT: 'MailboxThreadPrint',
  COMPOSE: 'Compose',
  COMPOSE_TAB: 'ComposeTab'
};
